// extracted by mini-css-extract-plugin
export default {"link":"Description__link--fkiPm"};